import script from "./HomeScreenHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeScreenHeader.vue?vue&type=script&lang=ts&setup=true"

import "./HomeScreenHeader.vue?vue&type=style&index=0&id=16298516&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16298516"]])

export default __exports__